import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IKendoComboBoxProps {
    controlId?: string;
    items: Immutable.List<string>;
    invalid?: boolean;
    selectedItem?: string;
    changeOperation?: number;
    disabled?: boolean;
    placeholder?: string;
    onChangeCallback?: (value: string) => void;
    onTextChangedCallback?: () => void;
    trottleonTextChangeEvent?: number;
    className?: string;
    focus?: boolean;
    operationArg1?: any;
    operationArg2?: any;
    operationArg3?: any;
}

class KendoComboBox extends React.Component<IKendoComboBoxProps, never> {
    private controlId: string;
    private reference: number;

    constructor(props: IKendoComboBoxProps) {
        super(props);

        if (this.props.controlId != null && this.props.controlId.trim().length > 0) {
            this.controlId = this.props.controlId;
        }
        else {
            this.controlId = GuidHelper.NewGuid();
        }
    }

    public render(): JSX.Element {
        return (<input disabled={this.props.disabled} id={this.controlId} className={this.props.className} />);
    }

    public componentDidMount(): void {
        $("#" + this.controlId).kendoComboBox({
            dataSource: {
                data: this.props.items.toArray()
            },
            ignoreCase: true,
            filter: "contains",
            suggest: true,
            clearButton: false,
            value: this.props.selectedItem,
            placeholder: this.props.placeholder,
            filtering: () => this.debounceType(),
            change: e => {
                if (this.props.changeOperation != null) {
                    var operation = new LocalEvent(this.props.changeOperation);
                    operation.AddItem("value", e.sender.value());
                    operation.AddItem("arg1", this.props.operationArg1);
                    operation.AddItem("arg2", this.props.operationArg2);
                    operation.AddItem("arg3", this.props.operationArg3);

                    LocalEventDispatcher.dispatch(operation);
                }

                if (this.props.onChangeCallback != null)
                    this.props.onChangeCallback(e.sender.value());
            }
        });

        if (this.props.focus === true) {
            window.setTimeout(() => {
                $("#" + this.controlId).data("kendoComboBox").input.focus();
            }, 30);
        }
    }

    public componentWillUnmount(): void {
        $("#" + this.controlId).data("kendoComboBox").destroy();
    }

    public shouldComponentUpdate(nextProps: IKendoComboBoxProps): boolean {
        return (
            nextProps.items !== this.props.items
            || nextProps.selectedItem !== this.props.selectedItem
        );
    }

    public componentDidUpdate(): void {
        const control = $("#" + this.controlId).data("kendoComboBox");
        const parent = $("#" + this.controlId).siblings(".k-dropdown-wrap");
        if (this.props.invalid && !parent.hasClass("invalid")) {
            parent.addClass("invalid");
        }
        else if (!this.props.invalid && parent.hasClass("invalid")) {
            parent.removeClass("invalid");
        }
        control.enable(!this.props.disabled);
        control.dataSource.data(this.props.items.toArray());
        control.value(this.props.selectedItem);
    }

    private debounceType(): void {
        if (this.props.onTextChangedCallback == null) return;
        let tms = this.props.trottleonTextChangeEvent == null
            ? 800
            : this.props.trottleonTextChangeEvent;
        if (tms < 20)
            tms = 20;

        if (this.reference !== -1) {
            clearTimeout(this.reference);
            this.reference = -1;
        }
        this.reference = window.setTimeout(() => {
            const v = $("#" + this.controlId).parent().find("input.k-input").val();
            this.props.onChangeCallback(v);
        }, tms);
    }
}

export { IKendoComboBoxProps, KendoComboBox };
